import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import fetchPFP from '../../functions/fetchPFP';
import fetchUsernameWithUID from "../../functions/fetchUsernameWithUID";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/free-solid-svg-icons';

const GeneralPostComponent = ({ post }) => {
  const [creatorProfilePicture, setCreatorProfilePicture] = useState(null);
  const [isLoadingProfilePicture, setIsLoadingProfilePicture] = useState(false);
  const [profilePictureError, setProfilePictureError] = useState(null);
  const [authorUsername, setAuthorUsername] = useState(null);

  useEffect(() => {
    const fetchProfilePicture = async () => {
      if (!post.uid) return; // Skip if UID is not available
      setIsLoadingProfilePicture(true);
      try {
        const profilePictureURL = await fetchPFP(post.uid);
        setCreatorProfilePicture(profilePictureURL);
      } catch (error) {
        setProfilePictureError(error.message);
      } finally {
        setIsLoadingProfilePicture(false);
      }
      setAuthorUsername(await fetchUsernameWithUID(post.uid));
    };

    fetchProfilePicture();
  }, [post.uid]);

  const createdAtDate = new Date(post.createdAt._seconds * 1000); // Convert seconds to milliseconds

  return (
    <div className="border p-4 border-gray-300 pb-8 mb-8">
      {/* Post Header */}
      <div className="flex flex-row items-center mb-4 border-b border-gray-300 pb-4">
        {/* Post Creator Profile Picture */}
        {isLoadingProfilePicture ? (
          <p>Loading profile picture...</p>
        ) : profilePictureError ? (
          <p>Error loading profile picture: {profilePictureError}</p>
        ) : (
          creatorProfilePicture && 
          <Link to={`/users/${authorUsername}`} className=' '>
            <img src={creatorProfilePicture} alt="Profile" className="w-10 h-10 rounded-full mr-4" />
         </Link>
        )}

        {/* Post Creator Info */}
        <div>
            <Link to={`/users/${authorUsername}`} className=' '>
          <p className="text-lg font-semibold">
            <span className='text-blue-400'>@</span>
            {authorUsername}</p>
            </Link>
          <p className="text-sm text-gray-500" title={createdAtDate.toString()}>
            {createdAtDate.toDateString()} {/* Use toDateString to display date */}
          </p>
        </div>
      </div>

        {/* Render media component if available */}
      {post.image && (
        <img src={post.image} alt="Post Image" className="max-w-full mb-4 border m-auto" />
      )}

      {/* Render post likes */}
        <div className="flex items-center mb-4">
            
            <FontAwesomeIcon icon={faHeart} className="text-gray-500 mr-2" />
            <p>{post.likes} likes</p>
        </div>




      {/* Render post content */}
      <div dangerouslySetInnerHTML={{ __html: post.text }} />


    </div>
  );
};

GeneralPostComponent.propTypes = {
  post: PropTypes.shape({
    uid: PropTypes.string,
    username: PropTypes.string.isRequired,
    createdAt: PropTypes.shape({
      _seconds: PropTypes.number.isRequired,
      _nanoseconds: PropTypes.number.isRequired,
    }).isRequired,
    text: PropTypes.string.isRequired,
    image: PropTypes.string,
  }).isRequired,
};

export default GeneralPostComponent;
